

// import R3 from '@syman/burgeon-r3';

const { updateSessionObject, getSessionObject } = R3.default;


export default () => ({
  mounted() {
    if (!this._inactive) { // 当前组件处于激活状态时
      this.toTopPosition();// 刷新浏览器时滚动位置回到顶部

      window.addEventListener(`${this.moduleComponentName}globaVerifyMessageClosed`, () => { // 当前单对象渲染完成后派发的通知
        this.updateScrollPosition();
      });

      window.addEventListener('R3SingleButtonClick', (data) => {
        // 刷新前储存页面滚动位置，
        if (data.detail.type === 'refresh') { // 找到点击刷新按钮时派发的通知，将位置置为顶部
          this.toTopPosition();
        } else { // 除刷新外的其它按钮操作 ，执行后刷新界面，需滚动到记录位置 
          this.saveScrollPosition();
        }
      });
    }
  },
  methods: {
    toTopPosition() { // 滚动到顶部
      const dom = document.getElementsByClassName('formPanel');
      if (dom) {
        const datas = {
          k: this.$route.params.tableName,
          v: 0
        };
        updateSessionObject('scrollPosition', datas);
      }
    },
    saveScrollPosition() {
      const dom = document.getElementsByClassName('formPanel');
      if (dom && dom[0]) {
        const datas = {
          k: this.$route.params.tableName,
          v: dom[0].scrollTop 
        };
        updateSessionObject('scrollPosition', datas);
      }
    },
    updateScrollPosition() { 
      const dom = document.getElementsByClassName('formPanel');
      const scrollPosition = getSessionObject('scrollPosition');
      if (dom && dom[0]) {
        dom[0].style.scrollTop = `${scrollPosition[this.$route.params.tableName]}px`;
        dom[0].style.top = `${scrollPosition[this.$route.params.tableName]}px`;
        dom[0].scrollTop = `${scrollPosition[this.$route.params.tableName]}`;
      }
    }
  
  },
  activated() {
    if (!this._inactive) { // 当前组件处于激活状态时
      // 切换tab后，恢复之前滚动位置
      this.updateScrollPosition();
    }
  },
});
